import type { StaffUserSummary, SystemRole } from "@autoflow/types";
import { http } from "../../shared/api/http";

export type ManageableStaffRole = SystemRole.Admin | SystemRole.Manager | SystemRole.Advisor | SystemRole.Technician;
export type CreateStaffUserInput = {
  displayName: string;
  email: string;
  phone?: string;
  role: ManageableStaffRole;
  temporaryPassword: string;
  isActive: boolean;
};

export const usersApi = {
  list: async () => (await http.get<StaffUserSummary[]>("/v1/users")).data,
  create: async (input: CreateStaffUserInput) => (await http.post<StaffUserSummary>("/v1/users",input)).data,
  updateProfile: async (id: string,input: { displayName: string; email: string; phone?: string }) =>
    (await http.patch<StaffUserSummary>(`/v1/users/${id}/profile`,input)).data,
  updateRole: async (id: string,role: ManageableStaffRole) =>
    (await http.patch<StaffUserSummary>(`/v1/users/${id}/role`,{role})).data,
  resetPassword: async (id: string,temporaryPassword: string) => {
    await http.post(`/v1/users/${id}/password/reset`,{temporaryPassword});
  },
  updateStatus: async (id: string,isActive: boolean) =>
    (await http.patch<StaffUserSummary>(`/v1/users/${id}/status`,{isActive})).data
};
